import React from 'react';

interface AdhocErrorPanelProps {
  title: string;
  message: string;
  primaryLabel?: string;
  onPrimary: () => void;
  secondaryLabel?: string;
  onSecondary?: () => void;
}

const AdhocErrorPanel: React.FC<AdhocErrorPanelProps> = ({
  title,
  message,
  primaryLabel = 'Start Over',
  onPrimary,
  secondaryLabel,
  onSecondary,
}) => (
  <div
    style={{
      position: 'fixed',
      inset: 0,
      zIndex: 300,
      background: 'rgba(15, 23, 42, 0.72)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
    }}
  >
    <div
      style={{
        maxWidth: 440,
        width: '100%',
        background: '#fff',
        borderRadius: 20,
        padding: '28px 24px',
        boxShadow: '0 24px 64px rgba(0,0,0,0.25)',
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
      <h2 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 800, color: '#0f172a' }}>{title}</h2>
      <p style={{ margin: '0 0 24px', fontSize: 15, lineHeight: 1.6, color: '#64748b' }}>{message}</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <button
          type="button"
          onClick={onPrimary}
          style={{
            padding: '14px 20px',
            borderRadius: 12,
            border: 'none',
            background: '#0f766e',
            color: '#fff',
            fontWeight: 700,
            fontSize: 15,
            cursor: 'pointer',
          }}
        >
          {primaryLabel}
        </button>
        {secondaryLabel && onSecondary && (
          <button
            type="button"
            onClick={onSecondary}
            style={{
              padding: '12px 20px',
              borderRadius: 12,
              border: '1px solid #e2e8f0',
              background: '#fff',
              color: '#475569',
              fontWeight: 600,
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            {secondaryLabel}
          </button>
        )}
      </div>
    </div>
  </div>
);

export default AdhocErrorPanel;
